import { SVGComponentPropsType } from './types';

export default (props: Omit<SVGComponentPropsType, 'color' | 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" {...props}>
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <rect stroke="#DADEE6" fillOpacity=".4" fill="#DADEE6" x="-.5" y="-.5" width="17" height="17" rx="2" />
      <rect fill="#9DA1AA" x="2" y="2" width="5" height="5" rx="1" />
      <rect fill="#9DA1AA" x="2" y="9" width="5" height="5" rx="1" />
      <rect fill="#9DA1AA" x="9" y="2" width="5" height="5" rx="1" />
      <rect fill="#F5920A" x="9" y="9" width="5" height="5" rx="1" />
    </g>
  </svg>
);
